import { IApiError } from '@frontend/request';

import {
  IAccountExperienceParams,
  IAccountExperienceRegister,
  IAccountExperienceResetPassword,
  accountExperienceAPI
} from '@aqx-core/common/api/account-experience';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class AccountExperienceAPIController {
  public resetPassword = async (
    params: IAccountExperienceParams,
    callbacks: IAPIControllerCallbacks<IAccountExperienceResetPassword>
  ) => {
    try {
      const { result } = await accountExperienceAPI.resetPassword(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public registerAccount = async (
    params: IAccountExperienceParams,
    callbacks: IAPIControllerCallbacks<IAccountExperienceRegister>
  ) => {
    try {
      const { result } = await accountExperienceAPI.register(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const accountExperienceAPIController = new AccountExperienceAPIController();
